// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#newId .aspect4 {
  width: 100%;
  position: relative;
  cursor: pointer;
}

#newId .modalImage {
  width: 100%;
  object-fit: contain;
  cursor: pointer;
}

#newId .modal-body {
  padding: 0px 0px 31px 0px !important;
}

#newId button.close {
  font-size: 31px !important;
  position: absolute;
  top: 5px;
  right: 10px;
  opacity: 1;
  color: var(--theme);
}

.dialog-action {
  text-align: center;
}

.yesNoBtn {
  height: auto;
  font-size: 18px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
